var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/* eslint-disable comma-dangle, no-var, react/jsx-closing-bracket-location, react/jsx-indent-props, react/sort-comp */
/* TODO(csilvers): fix these lint errors (http://eslint.org/docs/rules): */
/* To fix, remove an entry above, run ka-lint, and fix errors. */

var React = require("react");
var _ = require("underscore");

var Changeable = require("../mixins/changeable.jsx");
var EditorJsonify = require("../mixins/editor-jsonify.jsx");

var InfoTip = require("../components/info-tip.jsx");
var NumberInput = require("../components/number-input.jsx");
var PropCheckBox = require("../components/prop-check-box.jsx");
var RangeInput = require("../components/range-input.jsx");

var defaultImage = {
    url: null,
    top: 0,
    left: 0
};

var MeasurerEditor = React.createClass({
    displayName: "MeasurerEditor",

    className: "perseus-widget-measurer",

    propTypes: _extends({}, Changeable.propTypes, {
        box: React.PropTypes.arrayOf(React.PropTypes.number),
        image: React.PropTypes.shape({
            url: React.PropTypes.string,
            top: React.PropTypes.number,
            left: React.PropTypes.number
        }),
        showProtractor: React.PropTypes.bool,
        showRuler: React.PropTypes.bool,
        rulerLabel: React.PropTypes.string,
        rulerTicks: React.PropTypes.number,
        rulerPixels: React.PropTypes.number,
        rulerLength: React.PropTypes.number
    }),

    getDefaultProps: function getDefaultProps() {
        return {
            box: [480, 480],
            image: {},
            showProtractor: true,
            showRuler: false,
            rulerLabel: "",
            rulerTicks: 10,
            rulerPixels: 40,
            rulerLength: 10
        };
    },

    render: function render() {
        var _this = this;

        var image = _.extend({}, defaultImage, this.props.image);

        return React.createElement(
            "div",
            { className: "perseus-widget-measurer" },
            React.createElement(
                "div",
                null,
                "Image displayed under protractor and/or ruler:"
            ),
            React.createElement(
                "div",
                null,
                "URL:",
                " ",
                React.createElement("input", {
                    type: "text",
                    className: "perseus-widget-measurer-url",
                    ref: "image-url",
                    defaultValue: image.url,
                    onChange: this._changeUrl
                }),
                React.createElement(
                    InfoTip,
                    null,
                    React.createElement(
                        "p",
                        null,
                        "Create an image in graphie, or use the \"Add image\" function to create a background."
                    )
                )
            ),
            image.url && React.createElement(
                "div",
                { className: "perseus-widget-row" },
                React.createElement(
                    "label",
                    { className: "perseus-widget-left-col" },
                    "Pixels from top:",
                    " ",
                    React.createElement(NumberInput, {
                        placeholder: 0,
                        onChange: this._changeTop,
                        value: image.top,
                        useArrowKeys: true
                    })
                ),
                React.createElement(
                    "label",
                    { className: "perseus-widget-right-col" },
                    "Pixels from left:",
                    " ",
                    React.createElement(NumberInput, {
                        placeholder: 0,
                        onChange: this._changeLeft,
                        value: image.left,
                        useArrowKeys: true
                    })
                )
            ),
            React.createElement(
                "div",
                null,
                "Containing area [width, height]:",
                " ",
                React.createElement(RangeInput, {
                    onChange: this.change("box"),
                    value: this.props.box,
                    useArrowKeys: true
                })
            ),
            React.createElement(
                "div",
                { className: "perseus-widget-row" },
                React.createElement(
                    "div",
                    { className: "perseus-widget-left-col" },
                    React.createElement(PropCheckBox, {
                        label: "Show ruler",
                        showRuler: this.props.showRuler,
                        onChange: this.props.onChange
                    })
                ),
                React.createElement(
                    "div",
                    { className: "perseus-widget-right-col" },
                    React.createElement(PropCheckBox, {
                        label: "Show protractor",
                        showProtractor: this.props.showProtractor,
                        onChange: this.props.onChange
                    })
                )
            ),
            this.props.showRuler && React.createElement(
                "div",
                null,
                React.createElement(
                    "div",
                    null,
                    React.createElement(
                        "label",
                        null,
                        " ",
                        "Ruler label:",
                        " ",
                        React.createElement(
                            "select",
                            {
                                onChange: function onChange(e) {
                                    return _this.change("rulerLabel", e.target.value);
                                },
                                value: this.props.rulerLabel
                            },
                            React.createElement(
                                "option",
                                { value: "" },
                                "None"
                            ),
                            React.createElement(
                                "optgroup",
                                { label: "Metric" },
                                this.renderLabelChoices([["milimeters", "mm"], ["centimeters", "cm"], ["meters", "m"], ["kilometers", "km"]])
                            ),
                            React.createElement(
                                "optgroup",
                                { label: "Imperial" },
                                this.renderLabelChoices([["inches", "in"], ["feet", "ft"], ["yards", "yd"], ["miles", "mi"]])
                            )
                        )
                    )
                ),
                React.createElement(
                    "div",
                    null,
                    React.createElement(
                        "label",
                        null,
                        " ",
                        "Ruler ticks:",
                        " ",
                        React.createElement(
                            "select",
                            {
                                onChange: function onChange(e) {
                                    return _this.change("rulerTicks", +e.target.value);
                                },
                                value: this.props.rulerTicks
                            },
                            _.map([1, 2, 4, 8, 10, 16], function (n) {
                                return React.createElement(
                                    "option",
                                    { key: n, value: n },
                                    n
                                );
                            })
                        )
                    )
                ),
                React.createElement(
                    "div",
                    null,
                    React.createElement(
                        "label",
                        null,
                        "Ruler pixels per unit:",
                        " ",
                        React.createElement(NumberInput, {
                            placeholder: 40,
                            onChange: this.change("rulerPixels"),
                            value: this.props.rulerPixels,
                            useArrowKeys: true
                        })
                    )
                ),
                React.createElement(
                    "div",
                    null,
                    React.createElement(
                        "label",
                        null,
                        "Ruler length in units:",
                        " ",
                        React.createElement(NumberInput, {
                            placeholder: 10,
                            onChange: this.change("rulerLength"),
                            value: this.props.rulerLength,
                            useArrowKeys: true
                        })
                    )
                )
            )
        );
    },

    change: function change() {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return Changeable.change.apply(this, args);
    },


    _changeUrl: function _changeUrl(e) {
        this._changeImage("url", e.target.value);
    },

    _changeTop: function _changeTop(newTop) {
        this._changeImage("top", newTop);
    },

    _changeLeft: function _changeLeft(newLeft) {
        this._changeImage("left", newLeft);
    },

    _changeImage: function _changeImage(subProp, newValue) {
        var image = _.clone(this.props.image);
        image[subProp] = newValue;
        this.change("image", image);
    },

    renderLabelChoices: function renderLabelChoices(choices) {
        return _.map(choices, function (nameAndValue) {
            var name = nameAndValue[0],
                value = nameAndValue[1];

            return React.createElement(
                "option",
                { key: value, value: value },
                name
            );
        });
    },

    serialize: function serialize() {
        return EditorJsonify.serialize.call(this);
    }
});

module.exports = MeasurerEditor;


/*****************
 ** WEBPACK FOOTER
 ** ./src/widgets/measurer-editor.jsx
 ** module id = 127
 ** module chunks = 0 1
 **/